import { flatten, isRegExp, escapeRegExp, isString } from 'lodash'

const process = (
  str: string,
  search: string | RegExp,
  replace: (piece: string) => any
) => {
  let re = search

  if (!isRegExp(re)) {
    re = new RegExp(`${escapeRegExp(re)}`, 'gi')
  }

  const pieces = str.split(re)
  const result = []
  const matches = Array.from(str.matchAll(re))

  for (let i = 0; i < pieces.length; i++) {
    if (pieces[i]) {
      result.push(pieces[i])
    }

    const match = matches[i]

    if (match) {
      const replaced = replace(match[0])
      result.push(replaced)
    }
  }

  return result
}

const replaceString = (
  str: string | any[],
  search: string | RegExp,
  replace: string | ((piece: string) => any)
) => {
  const source = Array.isArray(str) ? str : [str]
  const replaceFunction = isString(replace) ? () => replace : replace

  return flatten(
    source.map((x) => (isString(x) ? process(x, search, replaceFunction) : x))
  )
}

export default replaceString
